<template>
    <div>
        <datatable-filter v-show="datatable.filterStatus"
                           @filter="filter"
                           @filterClear="filterClear">
            <b-row>
                <b-col sm="6" md="4">
                    <b-form-group :label="$t('coop_company')">
                        <b-form-input v-model="datatable.queryParams.filter.company_name"/>
                    </b-form-group>
                </b-col>
                <b-col sm="6" md="4">
                    <b-form-group :label="$t('coop_location')">
                        <b-form-input v-model="datatable.queryParams.filter.location"/>
                    </b-form-group>
                </b-col>
            </b-row>
        </datatable-filter>
        <datatable :isLoading.sync="datatable.isLoading"
                   :columns="datatable.columns"
                   :rows="datatable.rows"
                   :total="datatable.total"
                   :queryParams="datatable.queryParams"
                   :lineNumbers="false"
                   @on-page-change="onPageChange"
                   @on-sort-change="onSortChange"
                   @on-per-page-change="onPerPageChange"
                   v-show="datatable.showTable"
        />

        <CommonModal ref="documentsModal" size="md" :onHideOnlyX="true">
            <template v-slot:CommonModalTitle>
                {{ $t('coop_documents') }}
            </template>
            <template v-slot:CommonModalContent>
                <div v-if="selectedApplication">
                    <div v-for="doc in documents" :key="doc.code" class="d-flex align-items-center mb-2">
                        <div class="mr-2" style="width: 60px">{{ doc.label }}</div>
                        <b-form-file v-model="doc.file" class="d-none" :ref="'fileInput_' + doc.code"/>
                        <b-button size="sm" variant="outline-secondary" class="mr-1"
                                  @click="$refs['fileInput_' + doc.code][0].$el.childNodes[0].click()">
                            <i class="ri-upload-cloud-2-line"></i>
                        </b-button>
                        <b-button size="sm" variant="outline-danger" class="mr-2" :disabled="!doc.file" @click="doc.file = null">
                            <i class="ri-delete-bin-line"></i>
                        </b-button>
                        <b-badge :variant="statusVariant(doc.status)">{{ $t(doc.status) }}</b-badge>
                    </div>
                    <b-button variant="primary" class="mt-2" @click="saveDocuments">{{ $t('save') }}</b-button>
                </div>
            </template>
        </CommonModal>
    </div>
</template>
<script>
    //Component
    import DatatableFilter from '@/components/datatable/DatatableFilter';
    import Datatable from '@/components/datatable/Datatable';
    import CommonModal from '@/components/elements/CommonModal';

    //Service
    import CoopAnnouncementService from '@/services/CoopAnnouncementService';
    import CoopApplicationService from '@/services/CoopApplicationService';

    //Other
    import qs from 'qs';

    export default {
        components: {
            DatatableFilter,
            Datatable,
            CommonModal
        },
        data() {
            return {
                selectedApplication: null,
                documents: [],
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: '',
                            field: 'buttons',
                            html: true,
                            hidden: false,
                            tdClass: 'p-0 text-center w-40 align-middle',
                            buttons: [
                                {
                                    text: this.$t('coop_posting_detail_apply'),
                                    class: 'ri-file-text-line',
                                    callback: (row) => {
                                        this.$router.push('/coop/student/postings/' + row.id);
                                    }
                                },
                                {
                                    text: this.$t('view'),
                                    class: 'ri-eye-line',
                                    show: (row) => !!row.application,
                                    callback: (row) => {
                                        this.$router.push('/coop/student/postings/' + row.id);
                                    }
                                },
                                {
                                    text: this.$t('coop_upload_document'),
                                    class: 'ri-upload-cloud-2-line',
                                    show: (row) => !!row.application,
                                    callback: (row) => {
                                        this.showDocuments(row);
                                    }
                                }
                            ]
                        },
                        {
                            label: this.toUpperCase('coop_company'),
                            field: 'company_name',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('coop_position'),
                            field: 'position',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('coop_posting_responsible'),
                            field: 'responsible_name',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('coop_location'),
                            field: 'location',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('coop_quota'),
                            field: 'quota',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('coop_last_application_date'),
                            field: 'last_application_date',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('coop_fee'),
                            field: 'fee',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('status'),
                            field: 'status',
                            formatFn: (status) => {
                                if (!status) return '-';
                                return status === 'in_review' ? this.$t('coop_status_in_review') : this.$t(status);
                            },
                            hidden: false
                        }
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        filter: {},
                        sort: 'id',
                        page: 1,
                        limit: 20
                    }
                }
            };
        },
        methods: {
            filter() {
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            filterClear() {
                this.datatable.queryParams.filter = {};
                this.getRows();
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                const sortType = params[0].type == 'desc' ? '-' : '';
                this.datatable.queryParams.sort = sortType + params[0].field;
                this.getRows();
            },
            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                return Promise.all([
                    CoopAnnouncementService.getAll(config),
                    CoopApplicationService.getAll()
                ]).then(([annResponse, appResponse]) => {
                    const applications = appResponse.data.data;
                    this.datatable.rows = annResponse.data.data.map(ann => {
                        const application = applications.find(app => app.posting_id === ann.id);
                        return {
                            ...ann,
                            application,
                            status: application ? application.status : null
                        };
                    });
                    this.datatable.total = annResponse.data.pagination.total;
                }).finally(() => {
                    this.datatable.isLoading = false;
                });
            },
            statusVariant(status) {
                if (status === 'accepted') return 'success';
                if (status === 'rejected') return 'danger';
                return 'warning';
            },
            showDocuments(row) {
                this.selectedApplication = row.application;
                this.documents = row.application.documents.map((doc) => ({...doc, file: null}));
                this.$refs.documentsModal.$refs.commonModal.show();
            },
            saveDocuments() {
                CoopApplicationService.saveDocuments(this.selectedApplication.id, this.documents).then(() => {
                    this.$toast.success(this.$t('coop_documents_saved_success'));
                    this.$refs.documentsModal.$refs.commonModal.hide();
                    this.getRows();
                });
            }
        },
        created() {
            this.getRows();
        }
    }
</script>
